import React from 'react'
import classes from './menuItems.module.scss'
import classNames from 'classnames/bind'
import PropTypes from 'prop-types';


const cx = classNames.bind(classes)


function MenuItem(props) {
    const getNavItemIndex = (index) => {
        const imgName = (index < 10) ? `0${index}`: index;
        return <img src={require(`../assets/${imgName}.svg`)} alt={""}/>

    };
    const labelClass = cx({
        selected: props.active,
        label: true
    });

    const itemClass = cx({
        item: true,
        indexHidden: props.hideIndex
    });

    return (
        <li className={itemClass} name={props.id}>
            {
                !props.hideIndex && <span className={classes.index} name={props.id}>{getNavItemIndex(props.index)}</span>
            }
            <span className={labelClass} name={props.id}>{props.label}</span>
        </li>
    )
}

MenuItem.propTypes = {
    active: PropTypes.bool,
    id: PropTypes.string,
    label: PropTypes.string 
};

function MenuItems(props) {
    return (
        <div className={classes.wrapper}>
            <div className={classes.header}>
                <div className={classes.logo}>
                    <img src={require('../../../images/sixt_logo_black.svg')} alt={""}/>
                </div>
                <button className={classes.cross} onClick={props.closeHandler}>
                    <img src={require('../../../images/close_icon_black.svg')} alt={""}/>
                </button>
            </div>
            <div onClick={props.selectionHandler}  onKeyDown={props.selectionHandler} role="button" tabIndex={0}>
                <ul>
                    {props.items.map((item, index)=>{
                        return <MenuItem key={item.id} {...item} index={index+1}/>
                    })}   
                </ul>           
            </div>
        </div> 
    )
}

MenuItems.propTypes = {
    closeHandler: PropTypes.func,
    selectionHandler: PropTypes.func,
    items: PropTypes.array 
};

export default MenuItems;
